import React, { createContext, useReducer, useEffect, useContext} from 'react';
import { CHANGE_REQUEST_SUCCESS, SET_REMARKS_VALUE, SET_ACTION_VALUE, CLEAR_FILTER, IS_CR_FILTER_APPLIED  } from '../actions/actionTypes';
import { fetchChangeRequestOverview, submitChangeRequestAction, downloadIntakeBook } from '../actions/actionSelectors';
import {CalendarChangeRequestContext} from '../context/CalendarChangeRequestProvider';
import { changeRequestReducer } from '../actions/change-request-reducer';
import { isValueNullOrUndefinedOrEmpty } from '../../common/utility/utility';
import { saveAs } from 'file-saver';

const initialState = { changeRequestDetails: [] }

export const ChangeRequestContext = createContext();

export function ChangeRequestProvider(props) {
    const { errorOrWarningHandler, setSubmitSuccess, setIsLoading } = useContext(CalendarChangeRequestContext); 
    const [state, dispatch] = useReducer(changeRequestReducer, initialState);
    const { changeRequestDetails, isClearFilter, isCrFilterApplied } = state;

    const checkIfModification = () =>{
        let error = "";       
        let isModificationError = false;

        changeRequestDetails && changeRequestDetails.map((d) => {
            if (!d.header.status > 1 && (d.header.action > 1 || d.header.approverRemarks != ""))  {
                    error = "modification_notsaved"; }   
        });

        if (error.trim() !== "") { isModificationError = true; }

        if (isModificationError) { errorOrWarningHandler(true, "unsaved_changes", true, "change_request_action"); } 
        else { if(props.isLogout) { props.clearSessionData(); }          
        }
    }

    useEffect(() => { if(props.isLogout) { checkIfModification(); }
    }, [ props.isLogout]);   

    useEffect(() => { fetchChangeRequestOverviewHandler(); }, []);

    const fetchChangeRequestOverviewHandler = async () => {
        setIsLoading(true); 
        await fetchChangeRequestOverview(!props.isNmbsUser ? props.BusinessPartnerCode: undefined)
            .then((data) => {    
                dispatch({
                    type: CHANGE_REQUEST_SUCCESS,
                    payload: {
                        changeRequestDetails: data && typeof(data) !== 'string' ? data : []                        
                    }
                });
                setIsLoading(false); 
            })
            .catch((error) => { errorOrWarningHandler(true, "wentwrong", true, "change_request_action"); })    
    }  

    const handlerOnDownloadClick = async (contractCode, revenueDate, downloadType, userCashRegisterFileName) => { 
        setIsLoading(true);
        await downloadIntakeBook(contractCode, revenueDate, downloadType)    
        .then((data)=>{
                setIsLoading(false);
                if(data != null) {
                saveAs(new Blob([data]), userCashRegisterFileName);
            }
            else { errorOrWarningHandler(true, "wentwrong", true, "change_request_action"); }
        })
        .catch((error) => { errorOrWarningHandler(true, "wentwrong", true, "change_request_action"); }) 
    }

    const handlerOnActionButtonClick = async (changeId, approverRemarks, actionId, filterData, setFilterData) => {
        if (!isValueNullOrUndefinedOrEmpty(changeId) && !isValueNullOrUndefinedOrEmpty(approverRemarks) && actionId > 1) {
            setIsLoading(true); 
            await submitChangeRequestAction(changeId, approverRemarks, actionId, props.UserId)
            .then((data) => { 
                if(data && data.id > 0)
                {                
                    dispatch({
                        type: CHANGE_REQUEST_SUCCESS,
                        payload: {
                            changeRequestDetails : setChangeRequestData(changeId, actionId, approverRemarks, data.submittedDateTime, filterData, setFilterData)
                        }
                    });
                    setSubmitSuccess();                    
                }
                else { errorOrWarningHandler(true, "wentwrong", true, "change_request_action"); }
            })
            .catch((error) => { errorOrWarningHandler(true, "wentwrong", true, "change_request_action"); })
        }
        else { errorOrWarningHandler(true, "all_mandatory", true, "change_request_action"); }
    } 
    
    const setChangeRequestData = (changeId, actionId, approverRemarks, submittedDateTime, filterData, setFilterData) => {
       if(filterData && filterData.length > 0){
           setChangeRequestOnFilters(changeId, actionId, approverRemarks, submittedDateTime,
             filterData, setFilterData)
       }

        let changedData =  changeRequestDetails.map((data)=> (data.header.changeRequestNumber === changeId) ?
                { ...data, ["header"] : { ...data["header"],
                                          status : +actionId,
                                          statusCode : +actionId === 2 ? "status_approved" : "status_declined",
                                          action : +actionId,
                                          approverRemarks : approverRemarks, 
                                          submittedDateTime : submittedDateTime}
                } : data)

       return changedData;
    }

    const setChangeRequestOnFilters = (changeId, actionId, approverRemarks, submittedDateTime, filterData, setFilterData) => {
       let changedData =  filterData.map((data)=> (data.header.changeRequestNumber === changeId) ?
                 { ...data, ["header"] : { ...data["header"],
                                           status : +actionId,
                                           statusCode : +actionId === 2 ? "status_approved" : "status_declined",
                                           action : +actionId,
                                           approverRemarks : approverRemarks, 
                                           submittedDateTime : submittedDateTime}
                 } : data)

        setFilterData(changedData);
        return changedData;
     }
    

    const handlerOnRemarksChange = async (changeId, remarks) => {
        dispatch({ type: SET_REMARKS_VALUE, payload: { changeId: changeId, remarks: remarks } });
    }

    const handlerOnActionChange = async (changeId, action) => {
        dispatch({ type: SET_ACTION_VALUE, payload: { changeId: changeId, action: action } });
    }
	
	const handlerOnClearFilterClick = (isClear) => {
        dispatch({ type: CLEAR_FILTER, payload: {isClearFilter: isClear} });
    }

    const handlerCrFilterApplied = (isFilterApplied) => {
        dispatch({ type: IS_CR_FILTER_APPLIED, payload: { isCrFilterApplied: isFilterApplied } });
    }												
    
    const provider = {
        changeRequestDetails,        
        handlerOnActionButtonClick,        
        handlerOnRemarksChange,
        handlerOnActionChange,
        handlerOnDownloadClick,
        handlerOnClearFilterClick,
        isCrFilterApplied,
        isClearFilter,
        handlerCrFilterApplied     
    };

    return (
        <ChangeRequestContext.Provider value={provider}>
            {props.children}
        </ChangeRequestContext.Provider>
    );
}
